const nextQueueIndex = (index: number, size: number): number => {
    if (index + 1 >= size) {
        return 0
    }

    return index + 1
}

class RingQueue<T> {
    private _items: Array<T | undefined>

    private _head = 0

    private _tail = 0

    private _count = 0

    private _size: number

    constructor(size: number) {
        this._size = size
        this._items = new Array(size)
    }

    get items(): Array<T | undefined> {
        return this._items
    }

    get head(): number {
        return this._head
    }

    get tail(): number {
        return this._tail
    }

    get count(): number {
        return this._count
    }

    clear(): void {
        this._items = new Array(this._size)
        this._head = 0
        this._tail = 0
        this._count = 0
    }

    enqueue(value: T): T | undefined {
        // eslint-disable-next-line init-declarations
        let droppedValue: T | undefined
        if (this._count >= this._size) {
            droppedValue = this._items[this._head]
            this._items[this._head] = undefined
            this._head = nextQueueIndex(this._head, this._size)
            this._count = Math.max(this._count - 1, 0)
        }

        this._items[this._tail] = value
        this._tail = nextQueueIndex(this._tail, this._size)
        this._count += 1

        return droppedValue
    }

    dequeue(): T | undefined {
        if (this._count <= 0) {
            return undefined
        }

        const value = this._items[this._head]
        this._items[this._head] = undefined
        this._head = nextQueueIndex(this._head, this._size)
        this._count = Math.max(this._count - 1, 0)
        return value
    }
}

export default RingQueue
